module.exports = __webpack_public_path__ + "assets/images/sizeofOffice-03.7f454b1e8af449d987c166a145f7a7cd.svg";